/* PhoneHub — Case Studio: preview each silicone case color on every iPhone color.
   The case photo stays untouched; only the camera plate (fixed outline below, same on every
   product image of this layout) is recolored to the chosen phone color, keeping its light & shadow. */
(function () {
  'use strict';
  var MASK = null;

  // Phone profiles for other models come from ph-case-mask-<prefix>.js (see prefixOf below).
  var PHONES = {
    '17': { label: 'iPhone 17 Pro Max', colors: [
      { id: '17-orange', name: 'Cosmic Orange', hex: '#DE804C' },
      { id: '17-blue', name: 'Deep Blue', hex: '#2F3B57' },
      { id: '17-silver', name: 'Silver', hex: '#D3D5D8' }
    ] },
    '18': { label: 'iPhone 18 Pro Max', colors: [
      { id: '18-black', name: 'Black', hex: '#3A3B3F' },
      { id: '18-silver', name: 'Silver', hex: '#D3D5D8' },
      { id: '18-glacier', name: 'Glacier', hex: '#B8C9D8' },
      { id: '18-burgundy', name: 'Burgundy', hex: '#613740' }
    ] }
  };

  var FAMILIES = [
    { id: 'all', name: 'All' }, { id: 'neutral', name: 'Neutrals' }, { id: 'blue', name: 'Blues' },
    { id: 'green', name: 'Greens' }, { id: 'pink', name: 'Pinks & Reds' }, { id: 'purple', name: 'Purples' }, { id: 'warm', name: 'Warm' }
  ];

  var maskData = null;
  function decodeMask() {
    if (maskData) return maskData;
    var out = new Uint8Array(MASK.w * MASK.h), p = 0;
    MASK.rle.split('.').forEach(function (t) {
      var v = +t.charAt(0), n = parseInt(t.slice(1), 36);
      out.fill(v, p, p + n); p += n;
    });
    if (p !== MASK.w * MASK.h && window.console) console.warn('ph-case-studio: mask size', p);
    maskData = out;
    return out;
  }

  function hexRgb(h) { return [parseInt(h.slice(1, 3), 16), parseInt(h.slice(3, 5), 16), parseInt(h.slice(5, 7), 16)]; }
  function sameOrigin(u) {
    if (!u) return u;
    var m = String(u).match(/\/files\/(.+)$/);
    return m ? '/cdn/shop/files/' + m[1] : u;
  }

  var bitmapCache = {};
  function loadBitmap(url) {
    url = sameOrigin(url);
    if (!bitmapCache[url]) {
      bitmapCache[url] = fetch(url).then(function (r) { if (!r.ok) throw new Error(r.status); return r.blob(); })
        .then(function (b) { return createImageBitmap(b); });
    }
    return bitmapCache[url];
  }

  // Draw the case photo at 1200×1200 and recolor the camera plate to `hex`.
  function paint(canvas, bitmap, hex) {
    if (!hex || !MASK) {
      var c0 = canvas.getContext('2d'); c0.fillStyle = '#ffffff'; c0.fillRect(0, 0, canvas.width, canvas.height);
      c0.drawImage(bitmap, 0, 0, canvas.width, canvas.height); return;
    }
    var S = MASK.size;
    var work = document.createElement('canvas');
    work.width = S; work.height = S;
    var x = work.getContext('2d', { willReadFrequently: true });
    x.fillStyle = '#ffffff'; x.fillRect(0, 0, S, S);
    x.drawImage(bitmap, 0, 0, S, S);
    var mk = decodeMask();
    var im = x.getImageData(MASK.x, MASK.y, MASK.w, MASK.h), o = im.data, i, k, L;
    var sum = 0, n = 0;
    for (i = 0; i < mk.length; i++) {
      if (mk[i] < 3) continue;
      k = i * 4; L = 0.2126 * o[k] + 0.7152 * o[k + 1] + 0.0722 * o[k + 2];
      if (L < 40) continue; sum += L; n++;
    }
    var Lm = n ? sum / n : 128, t = hexRgb(hex);
    for (i = 0; i < mk.length; i++) {
      var v = mk[i]; if (!v) continue;
      var w = v / 3; k = i * 4;
      L = 0.2126 * o[k] + 0.7152 * o[k + 1] + 0.0722 * o[k + 2];
      var f = L / Lm;
      o[k] = o[k] * (1 - w) + Math.min(255, t[0] * f) * w;
      o[k + 1] = o[k + 1] * (1 - w) + Math.min(255, t[1] * f) * w;
      o[k + 2] = o[k + 2] * (1 - w) + Math.min(255, t[2] * f) * w;
    }
    x.putImageData(im, MASK.x, MASK.y);
    var cx = canvas.getContext('2d');
    cx.clearRect(0, 0, canvas.width, canvas.height);
    cx.drawImage(work, 0, 0, canvas.width, canvas.height);
  }

  // Sample a swatch color from the case body of a thumbnail.
  function sampleColor(bitmap) {
    var c = document.createElement('canvas'); c.width = 60; c.height = 60;
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(bitmap, 0, 0, 60, 60);
    var d = x.getImageData(26, 40, 8, 8).data, r = 0, g = 0, b = 0, n = 0;
    for (var i = 0; i < d.length; i += 4) { r += d[i]; g += d[i + 1]; b += d[i + 2]; n++; }
    return [Math.round(r / n), Math.round(g / n), Math.round(b / n)];
  }
  function family(rgb) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255;
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b), l = (mx + mn) / 2, d = mx - mn;
    var s = d === 0 ? 0 : d / (1 - Math.abs(2 * l - 1));
    if (s < 0.16 || l < 0.12) return 'neutral';
    var h = mx === r ? ((g - b) / d) % 6 : mx === g ? (b - r) / d + 2 : (r - g) / d + 4;
    h = (h * 60 + 360) % 360;
    if (h >= 335 || h < 12) return 'pink';
    if (h < 70) return (s < 0.3 && l > 0.6) ? 'neutral' : 'warm';
    if (h < 175) return 'green';
    if (h < 238) return 'blue';
    if (h < 322) return 'purple';
    return 'pink';
  }
  function dist(a, b) { var dr = a[0] - b[0], dg = a[1] - b[1], db = a[2] - b[2]; return 2 * dr * dr + 4 * dg * dg + 3 * db * db; }

  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function titleCase(s) { return String(s).replace(/\b([a-z])/g, function (m) { return m.toUpperCase(); }); }

  function init(root) {
    if (root.__phcst) return; root.__phcst = true;
    var data = JSON.parse(root.querySelector('[data-phcst-data]').textContent);
    // Multi-model products (e.g. Model: iPhone 17 | Air | Pro): one profile per model group.
    var profs = root.__phcstProfiles || null;
    var prof = root.__phcstProfile || null;
    if (profs) prof = profs[groupOf(data, data.selected)] || profs[Object.keys(profs)[0]];
    function profPhones(p, g) {
      var out = {};
      Object.keys(p.phones).forEach(function (m) {
        var s = p.phones[m];
        out[m] = { label: s.label + (p.maxSuffix && /pro\s*max/i.test(g || '') ? ' Max' : ''), short: s.short, colors: s.colors };
      });
      return out;
    }
    MASK = (prof ? prof.mask : window.PH_CASE_MASK) || null;
    var lite = (data.mode !== 'full' && !prof) || !MASK;
    root.classList.toggle('is-lite', lite);
    var phoneKey = prof ? (prof.key || 'ph:phone:' + prof.id) : 'ph:phone';
    if (prof) PHONES = profPhones(prof, profs ? groupOf(data, data.selected) : null);
    else Object.keys(PHONES).forEach(function (m) { PHONES[m].label = 'iPhone ' + m + ' ' + (data.suffix || 'Pro Max'); });
    var firstModel = Object.keys(PHONES)[0];
    root.classList.toggle('is-one-model', Object.keys(PHONES).length < 2);
    // Products with two options (e.g. Model + Color): color = swatches, the other option = a chip row.
    var opts = data.opts || [], ci = -1;
    opts.forEach(function (n, i) { if (/colou?r/i.test(n)) ci = i; });
    if (ci === -1) ci = opts.length - 1;
    var gi = opts.length === 2 ? 1 - ci : -1;
    var variants = data.variants.map(function (v) {
      v.name = titleCase(opts.length > 1 && v.o ? v.o[ci] : v.title);
      v.group = gi >= 0 && v.o ? v.o[gi] : null;
      v.rgb = null; v.fam = 'neutral'; return v;
    });
    var groups = [];
    variants.forEach(function (v) { if (v.group !== null && groups.indexOf(v.group) === -1) groups.push(v.group); });
    function inGroup(v) { return gi < 0 || v.group === state.group; }
    var byId = {}; variants.forEach(function (v) { byId[v.id] = v; });

    var saved = null;
    try { saved = JSON.parse(localStorage.getItem(phoneKey) || 'null'); } catch (e) {}
    var state = {
      model: saved && PHONES[saved.model] ? saved.model : firstModel,
      phone: saved && saved.phone ? saved.phone : PHONES[firstModel].colors[0].id,
      variant: byId[data.selected] ? data.selected : variants[0].id,
      fam: 'all',
      pack: [],
      photo: null,
      group: null
    };
    state.group = byId[state.variant].group;
    function phoneObj() {
      var list = PHONES[state.model].colors;
      return list.find(function (p) { return p.id === state.phone; }) || list[0];
    }
    if (!PHONES[state.model].colors.some(function (p) { return p.id === state.phone; })) state.phone = PHONES[state.model].colors[0].id;

    var q = function (s) { return root.querySelector(s); };
    var stageCanvas = q('[data-phcst-canvas]');
    var stagePhoto = q('[data-phcst-photo]');
    var stage = q('[data-phcst-stage]');
    var stageLabel = q('[data-phcst-stage-label]');
    var strip = q('[data-phcst-strip]');
    var stripTitle = q('[data-phcst-strip-title]');
    var models = q('[data-phcst-models]');
    var phones = q('[data-phcst-phones]');
    var fams = q('[data-phcst-fams]');
    var grid = q('[data-phcst-grid]');
    var matches = q('[data-phcst-matches]');
    var matchTitle = q('[data-phcst-match-title]');
    var caseName = root.querySelectorAll('[data-phcst-case-name]');
    var phoneName = root.querySelectorAll('[data-phcst-phone-name]');
    var stock = root.querySelectorAll('[data-phcst-stock]');
    var modsAll = root.querySelectorAll('[data-phcst-mods]'), mods = modsAll[0], pdots = q('[data-phcst-pdots]'), rail = q('[data-phcst-rail]'), famsM = q('[data-phcst-fams-m]'), countEl = q('[data-phcst-count]');
    var matchIds = [];
    var price = root.querySelectorAll('[data-phcst-price]');
    var addBtns = root.querySelectorAll('[data-phcst-add]');
    var packBox = q('[data-phcst-pack]');
    var packRail = q('[data-phcst-pack-rail]'), packStatus = q('[data-phcst-pack-status]');
    var packAdd = q('[data-phcst-pack-add]');
    var toast = q('[data-phcst-toast]');
    var barThumb = q('[data-phcst-bar-canvas]');
    var photos = q('[data-phcst-photos]');
    var barThumbBtn = q('[data-phcst-bar-thumb]');
    var dock = q('[data-phcst-dock]'), dockRail = q('[data-phcst-dock-rail]'), pick = q('[data-phcst-pick]');
    var buyRow = q('.phcst-buy');
    var groupBoxes = root.querySelectorAll('[data-phcst-groups]');
    // Like the old product page: dark "Out of stock" layer over a sold-out color, variant name bottom-left.
    var oosEl = el('div', 'phcst-oos', 'Out of stock'), vnameEl = el('div', 'phcst-vname');
    stage.appendChild(oosEl); stage.appendChild(vnameEl);
    if (!document.getElementById('phcst-extra-css')) {
      var st = el('style'); st.id = 'phcst-extra-css';
      st.textContent = '.phcst .phcst-label{display:none!important}' +
        '.phcst-oos{position:absolute;inset:0;display:none;align-items:center;justify-content:center;background:rgba(0,0,0,.35);color:#fff;font-size:22px;font-weight:700;text-transform:uppercase;letter-spacing:.02em;z-index:2;pointer-events:none}' +
        '.phcst-vname{position:absolute;left:10px;bottom:10px;z-index:3;background:rgba(0,0,0,.68);color:#fff;-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px);border-radius:999px;padding:6px 10px;font-size:11px;font-weight:600;line-height:1.1;white-space:nowrap;max-width:calc(100% - 20px);overflow:hidden;text-overflow:ellipsis;pointer-events:none}' +
        '.phcst-vname:empty{display:none}.phcst-stage .phcst-nav{z-index:4}';
      document.head.appendChild(st);
    }

    var renderToken = 0;
    function renderStage() {
      var v = byId[state.variant], p = phoneObj(), token = ++renderToken;
      stageLabel.innerHTML = '<span class="phcst-dot" style="background:' + p.hex + '"></span>On your ' + esc(p.name) + ' ' + esc(PHONES[state.model].label);
      vnameEl.textContent = state.photo ? '' : (v.group ? v.group + ' / ' : '') + v.name;
      oosEl.style.display = !v.available && !state.photo ? 'flex' : 'none';
      if (state.photo) { stage.classList.add('is-photo'); stagePhoto.src = state.photo; return; }
      stage.classList.remove('is-photo');
      if (!v.img) { stage.classList.add('is-empty'); return; }
      stage.classList.remove('is-empty');
      stage.classList.add('is-loading');
      loadBitmap(v.img).then(function (bm) {
        if (token !== renderToken) return;
        paint(stageCanvas, bm, lite ? null : p.hex);
        if (barThumb) paint(barThumb, bm, lite ? null : p.hex);
        stage.classList.remove('is-loading');
      }).catch(function () { stage.classList.remove('is-loading'); stage.classList.add('is-empty'); });
    }

    function renderStrip() {
      if (lite) return;
      var v = byId[state.variant];
      if (stripTitle) stripTitle.textContent = v.name + ' on every ' + PHONES[state.model].label + ' color';
      strip.innerHTML = '';
      PHONES[state.model].colors.forEach(function (p) {
        var b = el('button', 'phcst-mini' + (p.id === state.phone ? ' is-on' : ''));
        b.type = 'button'; b.setAttribute('aria-pressed', p.id === state.phone);
        var c = el('canvas'); c.width = 240; c.height = 240;
        b.appendChild(c); b.appendChild(el('span', '', esc(p.name)));
        b.addEventListener('click', function () { setPhone(state.model, p.id); });
        strip.appendChild(b);
        if (v.img) loadBitmap(v.img).then(function (bm) { paint(c, bm, p.hex); });
      });
    }

    function renderPhones() {
      var oneModel = Object.keys(PHONES).length < 2;
      if (models) {
      models.style.display = oneModel ? 'none' : '';
      models.innerHTML = '';
      Object.keys(PHONES).forEach(function (m) {
        var b = el('button', 'phcst-seg' + (m === state.model ? ' is-on' : ''), esc(PHONES[m].label));
        b.type = 'button'; b.setAttribute('aria-pressed', m === state.model);
        b.addEventListener('click', function () {
          var keep = PHONES[m].colors.find(function (p) { return p.name === phoneObj().name; });
          setPhone(m, keep ? keep.id : PHONES[m].colors[0].id);
        });
        models.appendChild(b);
      });
      phones.innerHTML = '';
      PHONES[state.model].colors.forEach(function (p) {
        var b = el('button', 'phcst-phone' + (p.id === state.phone ? ' is-on' : ''),
          '<span class="phcst-dot phcst-dot--lg" style="background:' + p.hex + '"></span><span>' + esc(p.name) + '</span>');
        b.type = 'button'; b.setAttribute('aria-pressed', p.id === state.phone);
        b.addEventListener('click', function () { setPhone(state.model, p.id); });
        phones.appendChild(b);
      });
      }
      phoneName.forEach(function (n) { n.textContent = phoneObj().name; });
      if (mods) {
        modsAll.forEach(function (box) {
        box.style.display = oneModel ? 'none' : '';
        box.innerHTML = '';
        Object.keys(PHONES).forEach(function (m) {
          var b = el('button', m === state.model ? 'is-on' : '', esc(PHONES[m].short || PHONES[m].label.replace('iPhone ', '').replace(' ' + (data.suffix || 'Pro Max'), '')));
          b.type = 'button'; b.setAttribute('aria-label', PHONES[m].label); b.setAttribute('aria-pressed', m === state.model);
          b.addEventListener('click', function () {
            var keep = PHONES[m].colors.find(function (p) { return p.name === phoneObj().name; });
            setPhone(m, keep ? keep.id : PHONES[m].colors[0].id);
          });
          box.appendChild(b);
        });
        });
        if (pdots) {
        pdots.innerHTML = '';
        PHONES[state.model].colors.forEach(function (p) {
          var b = el('button', 'phcst-pdot' + (p.id === state.phone ? ' is-on' : ''));
          b.type = 'button'; b.style.background = p.hex;
          b.setAttribute('aria-label', 'My iPhone is ' + p.name); b.setAttribute('aria-pressed', p.id === state.phone);
          b.addEventListener('click', function () { setPhone(state.model, p.id); });
          pdots.appendChild(b);
        });
        pdots.appendChild(el('b', '', esc(phoneObj().name)));
        }
      }
    }

    function swatch(v, small) {
      var b = el('button', 'phcst-sw' + (small ? ' phcst-sw--sm' : '') + (v.id === state.variant ? ' is-on' : '') + (v.available ? '' : ' is-sold'));
      b.type = 'button';
      b.setAttribute('aria-label', v.name + (v.available ? '' : ' (sold out)'));
      b.setAttribute('aria-pressed', v.id === state.variant);
      b.title = v.name + (v.available ? '' : ' — sold out');
      b.setAttribute('data-vid', v.id);
      if (v.thumb) b.style.backgroundImage = 'url(' + v.thumb + ')';
      else if (v.rgb) b.style.background = 'rgb(' + v.rgb.join(',') + ')';
      b.addEventListener('click', function () { setVariant(v.id); });
      return b;
    }

    function listFor(fam) {
      if (fam === 'match') return matchIds.map(function (id) { return byId[id]; });
      return variants.filter(function (v) { return inGroup(v) && (fam === 'all' || v.fam === fam); });
    }
    function renderFams() {
      [fams, famsM].forEach(function (box, mobile) {
        if (!box) return;
        box.innerHTML = '';
        var list = FAMILIES.slice();
        if (mobile && matchIds.length) list.splice(1, 0, { id: 'match', name: 'Suits your ' + phoneObj().name });
        list.forEach(function (f) {
          if (!mobile && f.id === 'match') return;
          var count = listFor(f.id).length;
          if (!count) return;
          var b = el('button', 'phcst-chip' + (f.id === state.fam ? ' is-on' : ''), esc(f.name) + (f.id === 'match' ? '' : ' <span>' + count + '</span>'));
          b.type = 'button'; b.setAttribute('aria-pressed', f.id === state.fam);
          b.addEventListener('click', function () { state.fam = f.id; renderFams(); renderGrid(); });
          box.appendChild(b);
        });
      });
    }
    function renderGrid() {
      var fam = state.fam === 'match' && !mobileView() ? 'all' : state.fam;
      grid.innerHTML = '';
      listFor(fam).forEach(function (v) { grid.appendChild(swatch(v)); });
      if (rail) {
        rail.innerHTML = '';
        var l = listFor(state.fam);
        l.forEach(function (v) { rail.appendChild(swatch(v)); });
        if (dockRail) { dockRail.innerHTML = ''; l.forEach(function (v) { var b = swatch(v); b.addEventListener('click', jumpToStage); dockRail.appendChild(b); }); }
        if (countEl) countEl.textContent = l.length + (l.length === 1 ? ' color' : ' colors');
        centerRail(false);
      }
    }
    function mobileView() { return window.matchMedia('(max-width: 989.98px)').matches; }
    function centerRail(smooth) {
      [rail, dockRail].forEach(function (r) {
        if (!r || !r.clientWidth) return;
        var on = r.querySelector('.phcst-sw.is-on');
        if (!on) return;
        var a = on.getBoundingClientRect(), b = r.getBoundingClientRect();
        var left = r.scrollLeft + (a.left - b.left) - (b.width - a.width) / 2;
        if (smooth === false) { r.style.scrollBehavior = 'auto'; r.scrollLeft = left; r.style.scrollBehavior = ''; }
        else r.scrollTo({ left: left, behavior: 'smooth' });
      });
    }
    function step(dir) {
      var l = listFor(state.fam);
      var i = l.findIndex(function (v) { return v.id === state.variant; });
      if (i === -1) { l = variants.filter(inGroup); i = l.findIndex(function (v) { return v.id === state.variant; }); }
      var n = l[(i + dir + l.length) % l.length];
      if (n) setVariant(n.id);
    }
    function renderMatches() {
      if (lite) { matchIds = []; matches.parentNode.hidden = true; return; }
      var p = phoneObj(), t = hexRgb(p.hex);
      matchTitle.textContent = 'Close to your ' + p.name + ' iPhone';
      var list = variants.filter(function (v) { return inGroup(v) && v.available && v.rgb; })
        .sort(function (a, b) { return dist(a.rgb, t) - dist(b.rgb, t); }).slice(0, 8);
      matchIds = list.map(function (v) { return v.id; });
      list = list.slice(0, 5);
      matches.innerHTML = '';
      list.forEach(function (v) { matches.appendChild(swatch(v, true)); });
      matches.parentNode.hidden = !list.length;
    }

    function renderInfo() {
      var v = byId[state.variant];
      caseName.forEach(function (n) { n.textContent = v.name; });
      price.forEach(function (n) { n.innerHTML = v.price + (v.compare ? ' <s>' + v.compare + '</s>' : ''); });
      stock.forEach(function (n) { n.textContent = v.available ? 'In stock' : 'Sold out'; n.className = 'phcst-stock' + (v.available ? '' : ' is-out'); });
      addBtns.forEach(function (b) { b.disabled = !v.available; b.textContent = v.available ? (b.hasAttribute('data-short') ? 'Add' : 'Add to cart') : 'Sold out'; });
    }

    function money(c) {
      var f = data.money || '${{amount}}';
      return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
        var n = c / 100;
        if (k === 'amount_no_decimals') return Math.round(n).toLocaleString('en-US');
        if (k === 'amount_with_comma_separator') return n.toFixed(2).replace('.', ',');
        return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      });
    }
    function renderPack() {
      packBox.innerHTML = '';
      for (var i = 0; i < 3; i++) {
        var id = state.pack[i];
        if (id) {
          var v = byId[id];
          var b = el('div', 'phcst-slot is-full');
          if (v.thumb) b.style.backgroundImage = 'url(' + v.thumb + ')';
          b.innerHTML = (i === 2 ? '<span class="phcst-slot-free">FREE</span>' : '') + '<span>' + esc(v.name) + '</span>';
          if (v.group) b.title = v.name + ' · ' + v.group;
          var x = el('button', 'phcst-slot-x', '&times;'); x.type = 'button'; x.setAttribute('aria-label', 'Remove ' + v.name);
          (function (idx) { x.addEventListener('click', function () { state.pack.splice(idx, 1); renderPack(); }); })(i);
          b.appendChild(x);
          packBox.appendChild(b);
        } else {
          var next = i === state.pack.length;
          packBox.appendChild(el('div', 'phcst-slot' + (next ? ' is-next' : ''),
            (i === 2 ? '<span class="phcst-slot-free">FREE</span>' : '') + '<span class="phcst-slot-plus">+</span><span>' + (next ? 'Tap a color' : (i === 2 ? 'Free case' : 'Color ' + (i + 1))) + '</span>'));
        }
      }
      var n = state.pack.length;
      packStatus.className = 'phcst-pack-status' + (n === 3 ? ' is-done' : '');
      packStatus.textContent = n === 0 ? 'Pick 3 colors and pay for only 2.' : n === 1 ? '1 of 3 picked. Pick 2 more.' : n === 2 ? '2 of 3 picked. Add 1 more and it\'s FREE.' : '✓ Pack complete. The 3rd case is free.';
      var cents = state.pack.map(function (id) { return byId[id].cents || 0; });
      var total = cents.reduce(function (a, b) { return a + b; }, 0);
      packAdd.disabled = !n;
      if (n === 3) packAdd.innerHTML = 'Add 3 cases to cart · ' + money(total - Math.min.apply(null, cents)) + ' <s>' + money(total) + '</s>';
      else packAdd.textContent = n ? 'Add ' + n + (n === 1 ? ' case' : ' cases') + ' to cart · ' + money(total) : 'Choose your 3 colors';
      if (packRail) {
        packRail.querySelectorAll('[data-pvid]').forEach(function (s) {
          var c = state.pack.filter(function (id) { return String(id) === s.getAttribute('data-pvid'); }).length;
          var badge = s.querySelector('b');
          if (c && !badge) { badge = el('b'); s.appendChild(badge); }
          if (badge) { if (c) badge.textContent = c > 1 ? c + '×' : '✓'; else badge.remove(); }
        });
      }
    }
    function renderPackRail() {
      if (!packRail) return;
      packRail.innerHTML = '';
      variants.filter(inGroup).forEach(function (v) {
        var b = el('button', 'phcst-sw phcst-psw' + (v.available ? '' : ' is-sold'));
        b.type = 'button'; b.title = v.name + (v.available ? '' : ' — sold out');
        b.setAttribute('aria-label', 'Add ' + v.name + ' to pack'); b.setAttribute('data-pvid', v.id);
        if (v.thumb) b.style.backgroundImage = 'url(' + v.thumb + ')';
        b.disabled = !v.available;
        b.addEventListener('click', function () {
          if (state.pack.length >= 3) { packStatus.className = 'phcst-pack-status'; packStatus.textContent = 'Your pack is full. Tap × on a case to swap it.'; return; }
          state.pack.push(v.id); setVariant(v.id); renderPack();
        });
        packRail.appendChild(b);
      });
    }

    function setPhone(model, id) {
      state.model = model; state.phone = id; state.photo = null;
      try { localStorage.setItem(phoneKey, JSON.stringify({ model: model, phone: id })); } catch (e) {}
      renderPhones(); renderStage(); renderStrip(); renderMatches(); renderFams();
      if (state.fam === 'match') renderGrid();
    }
    function renderGroups() {
      groupBoxes.forEach(function (box) {
        if (gi < 0 || groups.length < 2) { box.hidden = true; return; }
        box.hidden = false;
        box.innerHTML = '<span class="phcst-groups-l">' + esc(titleCase(opts[gi])) + ':</span>';
        groups.forEach(function (g) {
          var b = el('button', 'phcst-chip' + (g === state.group ? ' is-on' : ''), esc(g));
          b.type = 'button'; b.setAttribute('aria-pressed', g === state.group);
          b.addEventListener('click', function () { setGroup(g); });
          box.appendChild(b);
        });
      });
    }
    // Switch camera mask + phone colors when the customer picks another model group.
    function switchProfile(g) {
      if (!profs || !profs[g]) return;
      var p = profs[g];
      var key = p.key || 'ph:phone:' + p.id;
      var np = profPhones(p, g);
      var same = p === prof && Object.keys(np).every(function (m) { return PHONES[m] && PHONES[m].label === np[m].label; });
      if (same) return;
      prof = p; MASK = p.mask; maskData = null; PHONES = np; phoneKey = key;
      root.classList.toggle('is-one-model', Object.keys(PHONES).length < 2);
      var sv = null;
      try { sv = JSON.parse(localStorage.getItem(phoneKey) || 'null'); } catch (e) {}
      var fm = Object.keys(PHONES)[0];
      state.model = sv && PHONES[sv.model] ? sv.model : fm;
      state.phone = sv && sv.phone && PHONES[state.model].colors.some(function (c) { return c.id === sv.phone; }) ? sv.phone : PHONES[state.model].colors[0].id;
      renderPhones(); renderStrip();
    }
    function setGroup(g) {
      if (g === state.group) return;
      var cur = byId[state.variant];
      state.group = g;
      switchProfile(g);
      var nv = variants.find(function (v) { return v.group === g && v.name === cur.name && v.available; }) ||
        variants.find(function (v) { return v.group === g && v.available; }) || variants.find(function (v) { return v.group === g; });
      renderGroups(); renderMatches(); renderFams(); renderGrid(); renderPackRail(); renderPack();
      if (nv) setVariant(nv.id);
    }
    function setVariant(id) {
      state.variant = id; state.photo = null;
      if (byId[id].group !== state.group && gi >= 0) { state.group = byId[id].group; switchProfile(state.group); renderMatches(); renderGroups(); renderFams(); renderGrid(); renderPackRail(); renderPack(); }
      renderInfo(); renderStage(); renderStrip();
      root.querySelectorAll('.phcst-sw').forEach(function (s) {
        var on = s.getAttribute('data-vid') === String(id);
        s.classList.toggle('is-on', on); s.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      centerRail(true);
      try { var u = new URL(location.href); u.searchParams.set('variant', id); history.replaceState(null, '', u); } catch (e) {}
    }

    function showToast(msg) {
      toast.innerHTML = msg; toast.hidden = false;
      clearTimeout(toast.__t); toast.__t = setTimeout(function () { toast.hidden = true; }, 5000);
    }
    function addItems(ids, btn, after) {
      btn.classList.add('is-busy'); btn.disabled = true;
      var short = btn.hasAttribute('data-short');
      btn.innerHTML = '<span class="phcst-spin"></span>' + (short ? '' : 'Adding…');
      var items = ids.map(function (id) { return { id: id, quantity: 1 }; });
      var restore = function () { btn.classList.remove('is-busy', 'is-done'); btn.disabled = false; if (after) after(); renderInfo(); renderPack(); };
      return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'Error'); return j; }); })
        .then(function () {
          btn.classList.remove('is-busy'); btn.classList.add('is-done');
          btn.innerHTML = short ? '✓ Added' : '✓ Added to cart';
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
          setTimeout(restore, 2500);
        })
        .catch(function (e) { btn.classList.remove('is-busy'); btn.disabled = false; renderInfo(); renderPack(); showToast('Could not add: ' + esc(e.message)); });
    }
    addBtns.forEach(function (b) { b.addEventListener('click', function () { addItems([state.variant], b); }); });
    packAdd.addEventListener('click', function () { if (state.pack.length) addItems(state.pack.slice(), packAdd, function () { state.pack = []; }); });

    // Real photos (non-variant product images)
    if (photos) {
      photos.querySelectorAll('[data-src]').forEach(function (b) {
        b.addEventListener('click', function () { state.photo = b.getAttribute('data-src'); renderStage(); });
      });
      var back = photos.querySelector('[data-phcst-preview]');
      if (back) back.addEventListener('click', function () { state.photo = null; renderStage(); });
    }

    // Measure the theme's floating tab bar (phones).
    function placeBar() {
      var tb = document.querySelector('.phtb-bar'), off = 0;
      if (tb && getComputedStyle(tb).display !== 'none') {
        var r = tb.getBoundingClientRect();
        if (r.height) off = Math.max(0, Math.round(window.innerHeight - r.top + 8));
      }
      root.style.setProperty('--phcst-off', off + 'px');
      root.classList.toggle('has-tabbar', off > 0);
    }
    placeBar();
    window.addEventListener('resize', placeBar);
    setTimeout(placeBar, 800);

    root.querySelectorAll('[data-phcst-step]').forEach(function (b) {
      b.addEventListener('click', function () { step(+b.getAttribute('data-phcst-step')); });
    });
    // Swipe the preview left/right to change case color.
    var sx = null, sy = 0;
    stage.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy; sx = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5 && !state.photo) step(dx < 0 ? 1 : -1);
    }, { passive: true });

    // From the floating bar: close it and bring the photo back under the header so the choice is visible.
    var jumping = false, jumpT = 0;
    function jumpToStage() {
      var hd = document.querySelector('.header-section.header-sticky .header, .header-sticky');
      var hh = hd ? hd.offsetHeight : 0;
      var y = window.scrollY + stage.getBoundingClientRect().top - hh - 8;
      jumping = true; dockShown = false; dock.classList.remove('is-on');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
      clearTimeout(jumpT); jumpT = setTimeout(function () { jumping = false; updateDock(); }, 1000);
    }
    if (barThumbBtn) barThumbBtn.addEventListener('click', jumpToStage);

    // Phones: show the floating color dock only once the picker under the photo has scrolled off screen.
    var dockShown = false, ticking = false;
    function updateDock() {
      ticking = false;
      if (!dock || !pick) return;
      var show = false;
      if (mobileView()) {
        var hd = document.querySelector('.header-section.header-sticky, .header-sticky'), top = 0;
        if (hd) { var hr = (hd.querySelector('.header') || hd).getBoundingClientRect(); if (hr.bottom > 0) top = hr.bottom; }
        root.style.setProperty('--phcst-top', Math.round(top + 6) + 'px');
        var p = pick.getBoundingClientRect(), r = root.getBoundingClientRect();
        show = !jumping && p.bottom < top + 10 && r.bottom > top + 220;
      }
      // Keep the WhatsApp bubble from covering the Add to cart row under the photo.
      var wa = document.getElementById('whatflow-button-container');
      if (wa && buyRow) {
        var br = buyRow.getBoundingClientRect();
        var hide = mobileView() && br.bottom > 0 && br.top < window.innerHeight;
        wa.style.visibility = hide ? 'hidden' : '';
      }
      if (show !== dockShown) {
        dockShown = show;
        dock.classList.toggle('is-on', show);
        if (show) centerRail(false);
      }
    }
    var dockT = 0;
    window.addEventListener('scroll', function () { updateDock(); clearTimeout(dockT); dockT = setTimeout(updateDock, 600); }, { passive: true });
    var hdrEl = document.querySelector('.header-section.header-sticky .header');
    if (hdrEl) hdrEl.addEventListener('transitionend', updateDock);
    setTimeout(updateDock, 1000); setTimeout(updateDock, 2500); setTimeout(updateDock, 6000);
    window.addEventListener('resize', updateDock);
    updateDock();

    // Phones: the breadcrumbs row is hidden, so move its collection pills under the photos ("Shop more").
    var more = q('[data-phcst-more]');
    if (more && mobileView()) {
      var pills = document.querySelector('[id$="__breadcrumbs"] .ph-pills');
      if (pills) { more.appendChild(pills); more.hidden = false; }
    }

    // First paint, then sample swatch colors for families & matches.
    renderGroups(); renderPhones(); renderInfo(); renderStage(); renderStrip(); renderPackRail(); renderPack(); renderFams(); renderGrid();
    Promise.all(variants.map(function (v) {
      if (!v.thumb) return null;
      return loadBitmap(v.thumb).then(function (bm) { v.rgb = sampleColor(bm); v.fam = family(v.rgb); }).catch(function () {});
    })).then(function () { renderMatches(); renderFams(); renderGrid(); });
  }

  // Other iPhone models: when every variant photo shares one file prefix (e.g. air17_, iph17_), load
  // ph-case-mask-<prefix>.js next to this file. It registers window.PH_CASE_PROFILES[prefix] =
  // { id, mask, phones } and the page switches to full mode for that model. No file = lite mode.
  function prefixOf(data) {
    var pre = null, ok = true;
    (data.variants || []).forEach(function (v) {
      if (!v.img) return;
      var f = String(v.img).split('?')[0].split('/').pop(), p = f.split('_')[0];
      if (pre === null) pre = p; else if (p !== pre) ok = false;
    });
    if (!ok || !pre || !/^[a-z][a-z0-9-]*$/i.test(pre) || /^i1[0-9]$/i.test(pre)) return null;
    return pre.toLowerCase();
  }
  // Two-option products: index of the non-color option (the "model group"), or -1.
  function groupIndex(data) {
    var opts = data.opts || [], ci = -1;
    opts.forEach(function (n, i) { if (/colou?r/i.test(n)) ci = i; });
    if (ci === -1) ci = opts.length - 1;
    return opts.length === 2 ? 1 - ci : -1;
  }
  function groupOf(data, vid) {
    var gi = groupIndex(data), v = (data.variants || []).find(function (x) { return x.id === vid; }) || (data.variants || [])[0];
    return gi >= 0 && v && v.o ? v.o[gi] : null;
  }
  // Each model group's photos share one prefix (e.g. iph17_, air17_, pro17_) -> { group: prefix }.
  function groupPrefixes(data) {
    var gi = groupIndex(data);
    if (gi < 0) return null;
    var by = {};
    (data.variants || []).forEach(function (v) { if (v.o) (by[v.o[gi]] = by[v.o[gi]] || []).push(v); });
    var out = {}, ok = true, n = 0;
    Object.keys(by).forEach(function (g) { var p = prefixOf({ variants: by[g] }); if (!p) ok = false; else { out[g] = p; n++; } });
    return ok && n > 1 ? out : null;
  }
  var SRC = (document.currentScript && document.currentScript.src) || '';
  var profLoading = {};
  function loadProfile(pre) {
    window.PH_CASE_PROFILES = window.PH_CASE_PROFILES || {};
    if (window.PH_CASE_PROFILES[pre]) return Promise.resolve(window.PH_CASE_PROFILES[pre]);
    if (!profLoading[pre]) profLoading[pre] = new Promise(function (res) {
      var s = document.createElement('script');
      s.src = SRC.replace(/ph-case-studio\.js/, 'ph-case-mask-' + pre + '.js');
      s.onload = function () { res(window.PH_CASE_PROFILES[pre] || null); };
      s.onerror = function () { res(null); };
      document.head.appendChild(s);
    });
    return profLoading[pre];
  }
  function start(r) { try { init(r); } catch (e) { if (window.console) console.warn('ph-case-studio', e); } }
  function boot() {
    document.querySelectorAll('[data-phcst]').forEach(function (r) {
      if (r.__phcst) return;
      var d = null;
      try { d = JSON.parse(r.querySelector('[data-phcst-data]').textContent); } catch (e) {}
      var gp = d && d.mode !== 'full' ? groupPrefixes(d) : null;
      if (gp) {
        var gs = Object.keys(gp);
        Promise.all(gs.map(function (g) { return loadProfile(gp[g]); })).then(function (ps) {
          if (ps.every(function (p) { return p && p.mask && p.phones; })) {
            r.__phcstProfiles = {}; gs.forEach(function (g, i) { r.__phcstProfiles[g] = ps[i]; });
          }
          start(r);
        });
        return;
      }
      var pre = d && d.mode !== 'full' ? prefixOf(d) : null;
      if (pre) loadProfile(pre).then(function (p) { if (p && p.mask && p.phones) r.__phcstProfile = p; start(r); });
      else start(r);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
